module.exports = __webpack_public_path__ + "img/logo-hotelv-frederiksplein.ceb89402ff32ef63cd8324a4a70ab2de.svg";